import { USERS } from "../types";

export const usersReducer = (state = {}, action) => {
  switch (action.type) {
    case USERS:
      return { items: action.payload, filteredItems: action.payload };
    default:
      return state;
  }
};
